// Copyright 2025 Mo-Sys Engineering Ltd. All Rights Reserved.
import React from "react";

import { MinusForm } from "./Misc/MinusForm";
import { Plus } from "./Misc/Plus";
import { Led } from "./Misc/Led";
import { Share } from "./Misc/Share";
import { Logout } from "./Misc/Logout";
import { Data } from "./Misc/Data";
import { Lens } from "./Misc/Lens";
import { Network } from "./Misc/Network";
import { Mapping } from "./Misc/Mapping";
import { Add } from "./Misc/Add";
import { Minus } from "./Misc/Minus";
import { ZoomIn } from "./Misc/ZoomIn";
import { ZoomOut } from "./Misc/ZoomOut";


import { ArrowDown } from "./Misc/ArrowDown";
import { ArrowUp } from "./Misc/ArrowUp";
import { ArrowLeft } from "./Misc/ArrowLeft";
import { ArrowRight } from "./Misc/ArrowRight";
import { Menu } from "./Misc/Menu";
import { AddStars } from "./Misc/AddStars";
import { LinkExternal } from "./Misc/LinkExternal";
import { Close } from "./Misc/Close";
import { StarStatus } from "./Misc/StarStatus";
import { Error } from "./Misc/Error";
import { Check } from "./Misc/Check";
import { Success } from "./Misc/Success";
import { Delay } from "./Misc/Delay";
import { List } from "./Misc/List";
import { Lock } from "./Misc/Lock";
import { Unlock } from "./Misc/Unlock";
import { Maximize } from "./Misc/Maximize";
import { Minimize } from "./Misc/Minimize";
import { Settings } from "./Misc/Settings";
import { DownLoad } from "./Misc/DownLoad";
import { Warning } from "./Misc/Warning";
import { Info } from "./Misc/Info";
import { Upload } from "./Misc/Upload";
import { Support } from "./Misc/Support";
import { Feedback } from "./Misc/Feedback";
import { Search } from "./Misc/Search";
import { Searchnotfound } from "./Misc/Searchnotfound";
import { Offline } from "./Misc/Offline";
import { DataOff } from "./Misc/DataOff";
import { Users } from "./Misc/Users";
import { User } from "./Misc/User";
import { AddUser } from "./Misc/AddUser";
import { UsersEmail } from "./Misc/UsersEmail";
import { UserConfiguration } from "./Misc/UserConfiguration";
import { Devicesmanage } from "./Misc/Devicesmanage";
import { LedRing } from "./Misc/LedRing";
import { Link } from "./Misc/Link";
import { LinkOff } from "./Misc/LinkOff";
import { Undo } from "./Misc/Undo";
import { Help } from "./Misc/Help";
import { Edit } from "./Misc/Edit";
import { Delete } from "./Misc/Delete";
import { Alert } from "./Misc/Alert";
import { Notification } from "./Misc/Notification";

import { Offsets } from "./Misc/Offsets";
import { Explore } from "./Misc/Explore";
import { Library } from "./Misc/Library";
import { Threedots } from "./Misc/Threedots";
import { Keyword } from "./Misc/Keyword";
import { Control } from "./Misc/Control";
import { ControlBack } from "./Misc/ControlBack";
import { Email } from "./Misc/Email";
import { Card } from "./Misc/Card";
import { Filter } from "./Misc/Filter";
import { Script } from "./Misc/Script";
import { Center } from "./Misc/Center";
import { Dialogue } from "./Misc/Dialogue";
import { Desc } from "./Misc/Desc";
import { Heading } from "./Misc/Heading";
import { Copy } from "./Misc/Copy";
import { CopyLine } from "./Misc/CopyLine";
import { Paste } from "./Misc/Paste";
import { PasteLine } from "./Misc/PasteLine";
import { Cut } from "./Misc/Cut";
import { Duplicate } from "./Misc/Duplicate";
import { Dots } from "./Misc/Dots";
import { Drag } from "./Misc/Drag";

// StarTracker Icons
import { Geometry } from "./Misc/Geometry";
import { LensCalibration } from "./Misc/LensCalibration";
import { Verifier } from "./Misc/Verifier";
import { Ptz } from "./Misc/Ptz";
import { Connection } from "./Misc/Connection";
import { Record } from "./Misc/Record";
import { DataPacket } from "./Misc/DataPacket";
import { Vision } from "./Misc/Vision";
import { ZeroOffsets } from "./Misc/ZeroOffsets";

// MoStudio Icons
import { CameraRound } from "./Misc/CameraRound";
import { Plates } from "./Misc/Plates";
import { Positioning } from "./Misc/Positioning";
import { ColorWheel } from "./Misc/ColorWheel";
import { Mood } from "./Misc/Mood";
import { Camera } from "./Misc/Camera";
import { Actions } from "./Misc/Actions";
import { View } from "./Misc/View";
import { Home } from "./Misc/Home";
import { Screen } from "./Misc/Screen";
import { SelectAll } from "./Misc/SelectAll";
import { SelectNone } from "./Misc/SelectNone";
import { Joystick } from "./Misc/Joystick";

// Car Rig Icons
import { SteeringWheel } from "./Misc/SteeringWheel";
import { Stop } from "./Misc/Stop";
import { Pause } from "./Misc/Pause";
import { Play } from "./Misc/Play";
import { Start } from "./Misc/Start";
import { End } from "./Misc/End";
import { Restart } from "./Misc/Restart";

import styles from "./Icons.module.css";

const ICON_MAP = {
  // Basic icons
  plusForm: Plus,
  minusForm: MinusForm,
  ledOutput: Led,
  share: Share,
  logout: Logout,
  alert: Alert,
  notification: Notification,
  data: Data,
  history: List,
  delay: Delay,
  offsets: Offsets,
  verifier: Verifier,
  lens: Lens,
  mapping: Mapping,
  network: Network,
  connection: Connection,
  offline: Offline,
  dataOff: DataOff,
  geometry: Geometry,
  vision: Vision,
  zeroOffsets: ZeroOffsets,

  // User / Account
  user: User,
  users: Users,
  usersInvite: UsersEmail,
  usersConfiguation: UserConfiguration,
  devices: Devicesmanage,
  ptz: Ptz,
  settings: Settings,

  // Navigation arrows
  back: ArrowLeft,
  forward: ArrowRight,
  down: ArrowDown,
  up: ArrowUp,

  // Basic actions
  add: Add,
  minus: Minus,
  menu: Menu,
  stars: AddStars,
  close: Close,
  status: StarStatus,
  error: Error,
  success: Check,
  warning: Warning,
  info: Info,
  isSuccess: Success,
  help: Help,
  upload: Upload,
  download: DownLoad,
  led: LedRing,
  edit: Edit,
  search: Search,
  searchnotfound: Searchnotfound,
  support: Support,
  feedback: Feedback,
  delete: Delete,
  link: Link,
  linkExternal: LinkExternal,
  linkoff: LinkOff,
  undo: Undo,
  lock: Lock,
  unlock: Unlock,
  maximize: Maximize,
  minimize: Minimize,
  zoomIn: ZoomIn,
  zoomOut: ZoomOut,

  // Misc
  explore: Explore,
  library: Library,
  threeDots: Threedots,
  keyword: Keyword,
  control: Control,
  controlback: ControlBack,
  addUser: AddUser,
  email: Email,
  lensCalibration: LensCalibration,
  record: Record,
  dataPacket: DataPacket,
  cameraRound: CameraRound,
  card: Card,
  filter: Filter,
  script: Script,
  center: Center,
  dialogue: Dialogue,
  desc: Desc,
  heading: Heading,
  copy: Copy,
  copyLine: CopyLine,
  duplicate: Duplicate,
  paste: Paste,
  pasteLine: PasteLine,
  cut: Cut,
  dots: Dots,
  drag: Drag,

  // MoStudio / Special icons
  plates: Plates,
  positioning: Positioning,
  color: ColorWheel,
  mood: Mood,
  camera: Camera,
  actions: Actions,
  view: View,
  home: Home,
  screen: Screen,
  selectall: SelectAll,
  selectnone: SelectNone,
  joystick: Joystick,

  // Car Rig
  steeringwheel: SteeringWheel,
  play: Play,
  stop: Stop,
  pause: Pause,
  start: Start,
  end: End,
  restart: Restart,
};

export const Icons = ({
  iconType,
  iconSize = "24",
  sizing,
  background,
  stroke = "var(--color-light)",
  fill = "none",
}) => {
  if (!iconType) return null;

  const IconComponent = ICON_MAP[iconType];
  if (!IconComponent) return null;

  return (
    <span
      className={`${styles.icons} ${sizing ? styles.sizing : ""} ${background ? styles.background : ""
        }`}
      data-testid="svg-icon"
    >
      <IconComponent size={iconSize} stroke={stroke} fill={fill} />
    </span>
  );
};
